import { render } from "./PresentMonthSales.vue?vue&type=template&id=e770838a&scoped=true"
import script from "./PresentMonthSales.vue?vue&type=script&lang=js"
export * from "./PresentMonthSales.vue?vue&type=script&lang=js"

import "./PresentMonthSales.vue?vue&type=style&index=0&id=e770838a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e770838a"]])

export default __exports__